import React from 'react';

import Quicks from '../components/quicks';
import Journals from '../components/journals';
import Conferences from '../components/conferencees';
import Books from '../components/books';
import BookChapters from '../components/book-chapters';
import Patents from '../components/patents';
import Preprints from '../components/preprints';
import Dissertations from '../components/dissertations';

const Component = () => {
    return (
        <div>
            <Quicks
                external
                links={[
                    {
                        name: 'DBLP',
                        link: 'https://dblp.org/pid/18/7553.html'
                    },
                    {
                        name: 'Google Scholar',
                        link: 'http://scholar.google.co.in/citations?user=mA0HQJEAAAAJ&hl=en'
                    },
                    {
                        name: 'ORCiD',
                        link: 'https://orcid.org/0000-0002-8873-8258'
                    }
                ]}
                navs={[
                    { name: 'Journals', link: '#Journals' },
                    { name: 'Conferences', link: '#Conferences' },
                    { name: 'Books', link: '#Books' },
                    { name: 'Book Chapters', link: '#BookChapters' },
                    { name: 'Patents', link: '#Patents' },
                    { name: 'Preprints', link: '#Preprints' },
                    { name: 'Dissertation', link: '#Dissertation' }
                ]}
            />

            <Journals />
            <Conferences />
            <Books />
            <BookChapters />
            <Patents />
            <Preprints />
            <Dissertations />
        </div>
    );
};

export default Component;
